module.exports = __webpack_public_path__ + "img/11_18.c1b7cc9a.png";